/* eslint-disable */
import axios, { AxiosInstance } from "axios";
import Cookies from "js-cookie";
import i18n from "../../i18n";
import { baseUri, URL_SERVICE_PERSON } from "../../uri";
import { toast } from "react-toastify";
import { CREATE_TOAST, DELETE_TOAST, GET_TOASTS } from "../actionTypes";
import { getHeaders } from "./users.actions";


let axiosRequestServiceNotificationUrl: AxiosInstance;

export const initAxiosNotification = () => {
  getHeaders();

  axiosRequestServiceNotificationUrl = axios.create({
    baseURL: URL_SERVICE_PERSON,
    timeout: 1000,
    headers: { ...axios.defaults.headers.common }
  });
};

export const createToast =
  (toastData: any) =>
  async (dispatch: (arg0: { type: string; payload: void }) => void) => {
    try {
      const res = await axiosRequestServiceNotificationUrl.post(
        `/service-notification/v1/toasts`,
        toastData
      );
      dispatch({
        type: CREATE_TOAST,
        payload: res.data,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const getAllToasts =
  () => async (dispatch: (arg0: { type: string; payload: void }) => void) => {
    try {
      const res = await axiosRequestServiceNotificationUrl.get(
        `/service-notification/v1/toasts`
      );
      dispatch({
        type: GET_TOASTS,
        payload: res.data,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

export const deleteToast =
  (toastValueId: string) =>
  async (dispatch: (arg0: { type: string; payload: void }) => void) => {
    try {
      const res = await axiosRequestServiceNotificationUrl.delete(
        `/service-notification/v1/toasts/${toastValueId}`
      );
      dispatch({
        type: DELETE_TOAST,
        payload: res.data,
      });
      toast.success(i18n.t("SUCCESS"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (e) {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
